"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
exports.Divider = react_1.default.forwardRef(function (_a, ref) {
    var _b;
    var alignContent = _a.alignContent, children = _a.children, className = _a.className, el = _a.el, _c = _a.spacing, spacing = _c === void 0 ? 0 : _c, vertical = _a.vertical, props = __rest(_a, ["alignContent", "children", "className", "el", "spacing", "vertical"]);
    var DividerElement = el
        ? el
        : children
            ? 'div'
            : vertical
                ? 'span'
                : 'hr';
    var DividerClasses = classnames_1.default('Divider', className, (_b = {
            'Divider--has-children': children && el !== 'hr'
        },
        _b["Divider--spacing-" + spacing] = spacing,
        _b['Divider--vertical'] = vertical,
        _b));
    var line = react_1.default.createElement("div", { className: "Divider__line" });
    return (react_1.default.createElement(DividerElement, __assign({ ref: ref, className: DividerClasses }, props), children && el !== 'hr' ? (react_1.default.createElement(react_1.default.Fragment, null,
        alignContent === 'start' ? null : line,
        react_1.default.createElement("div", { className: "Divider__content" }, children),
        alignContent === 'end' ? null : line)) : null));
});
//# sourceMappingURL=Divider.js.map